import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ContactModal from './ContactModal';
import './Contact.css';

const CONTACT_EMAIL = 'd.osiecki@oftionn.com';

const LINKS = [
  { key: 'contact.links.tech',     href: 'https://deos.blog' },
  { key: 'contact.links.hardwareAi', href: 'https://oftionn.com' },
  { key: 'contact.links.linkedin', href: 'https://linkedin.com/in/dawid-osiecki-b8284858' },
  { key: 'contact.links.youtube',  href: 'https://www.youtube.com/@nom-ai-d' },
    { key: 'contact.links.lifestyle',     href: 'https://nomaid.blog' },
];

function Contact() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <section id="contact" className="contact">
      <div className="contact-left">
        <h2>{t('contact.heading')}</h2>
        <a href={`mailto:${CONTACT_EMAIL}`} className="contact-email">
          {CONTACT_EMAIL}
        </a>
      </div>

      <div className="contact-right">
        <button
          type="button"
          className="contact-cta"
          onClick={() => setOpen(true)}
        >
          {t('contact.cta')}
        </button>

        <ul className="contact-links">
          {LINKS.map(({ key, href }) => (
            <li key={key}>
              <a href={href} target="_blank" rel="noopener noreferrer">
                {t(key)}
              </a>
            </li>
          ))}
        </ul>
      </div>

      <ContactModal open={open} onClose={() => setOpen(false)} />
    </section>
  );
}

export default Contact;
